import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 15.167A7.173 7.173 0 0 1 .833 8 7.173 7.173 0 0 1 8 .833 7.173 7.173 0 0 1 15.167 8 7.173 7.173 0 0 1 8 15.167M8 1.833A6.174 6.174 0 0 0 1.833 8c0 3.4 2.767 6.167 6.167 6.167S14.167 11.4 14.167 8 11.4 1.833 8 1.833"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".667",
      d: "m6.231 10.005-.008.008a.15.15 0 0 1-.11.04.16.16 0 0 1-.117-.049.17.17 0 0 1 0-.235l3.773-3.773a.17.17 0 0 1 .235 0 .17.17 0 0 1 0 .235z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.887 10.387a.5.5 0 0 1-.354-.147L5.76 6.467a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l3.773 3.774a.503.503 0 0 1 0 .706c-.1.1-.227.147-.353.147"
    }, null, -1)
  ]))]))
}
export default { render: render }